import type React from "react";
import { cn } from "../utils/cn";

interface PlatformIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function PlatformIcon({ className, title = "Platform Icon", dark, ...props }: PlatformIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Platform Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        d="M4.85742 17.8574H3V16H4.85742V17.8574ZM6.71582 17.8574H4.85938V4.85742H6.71582V17.8574ZM8.5752 8.57129H10.4268V17.8574H8.56934V16H6.71777V12.2861H8.56934V10.4287H6.71777V6.71387H8.5752V8.57129ZM14.1387 17.8574H12.2822V16H10.4307V12.2861H12.2822V10.4287H10.4307V6.71387H12.2822V4.85742H14.1387V17.8574ZM15.998 17.8574H14.1406V16H15.998V17.8574ZM4.85742 14.1426H3V3H4.85742V14.1426ZM15.998 14.1426H14.1406V3H15.998V14.1426Z"
        fill={dark ? "white" : "black"}
      />
    </svg>
  );
}

export default PlatformIcon;
